import { Group, Stack, Text } from "@mantine/core"
import { CountryLabel, Missing } from "@tfg/ui"

import { CountryIso3166 } from "@tfg/types/endpoints/library"

import { COUNTRIES } from "~/utils/countries"

type Props = {
  productionSite?: {
    name: string
    address: string
    countryIso3166: CountryIso3166
  }
  showAddress?: boolean
  showCountry?: boolean
}

export const ProductionSiteCell = ({
  productionSite,
  showAddress = true,
  showCountry = true,
}: Props) => {
  if (!productionSite) return <Missing />

  const countryInfo = productionSite.countryIso3166
    ? COUNTRIES[productionSite.countryIso3166]
    : undefined

  return (
    <Stack gap={0}>
      <Text>{productionSite.name}</Text>
      <Group gap="xs">
        {showAddress && productionSite.address.length > 0 ? (
          <Text fz="xs" c="gray">
            {productionSite.address}
          </Text>
        ) : null}
        {countryInfo && showCountry ? (
          <>
            <Group fz="sm">
              <CountryLabel
                countryIso3166={countryInfo.code}
                width={12}
                countriesMapper={COUNTRIES}
              />
            </Group>
          </>
        ) : null}
      </Group>
    </Stack>
  )
}
